<template>
  <div class="my-5" :class="$vuetify.breakpoint.name === 'lg' ? 'pr-12 pl-9' : 'px-5'">
    <v-dialog v-model="dialog.form" 
      persistent
      scrollable
      width="500">
      <v-card class="border-radius box-shadow">
        <v-card-title class="body-2 text-first justify-center">
          Tambah Tipe Unit Baru
        </v-card-title>
        
        <v-card-text style="height: 700px;">
          <ValidationObserver ref="observer">
            <v-form class="pt-3">
              <ValidationProvider name="Nama Unit" rules="required" v-slot="{ errors }">
                <v-text-field
                  dense
                  outlined
                  single-line
                  label="Nama Unit"
                  :color="style.primary"
                  prepend-inner-icon="mdi-home-plus-outline"
                  v-model="form.name"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>
              <v-row>
                <v-col cols="6" class="py-0">
                  <ValidationProvider name="Jumlah Unit" rules="required" v-slot="{ errors }">
                    <v-text-field
                      type="number"
                      dense
                      outlined
                      single-line
                      label="Jumlah Unit"
                      :color="style.primary"
                      prepend-inner-icon="mdi-home-plus-outline"
                      v-model="form.total_unit"
                      :error-messages="errors"
                      require>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="6" class="py-0">
                  <ValidationProvider name="Prefix otomatis (ex: BA)" rules="required" v-slot="{ errors }">
                    <v-text-field
                      dense
                      outlined
                      single-line
                      label="Prefix otomatis (ex: BA)"
                      :color="style.primary"
                      prepend-inner-icon="mdi-home-plus-outline"
                      v-model="form.detail.prefix"
                      :error-messages="errors"
                      require>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>

              <v-radio-group
                v-model="form.detail.unit_jenis"
                row
                dense
                class="ma-0 pa-0">
                <v-radio
                  :color="style.primary"
                  label="Subsidi"
                  value="Subsidi">
                  <template v-slot:label>
                    <div class="color-default font-weight-bold">Subsidi</div>
                  </template>
                </v-radio>
                <v-radio
                  :color="style.primary"
                  label="Komersil"
                  value="Non Subsidi">
                  <template v-slot:label>
                    <div class="">Komersil</div>
                  </template>
                </v-radio>
              </v-radio-group>

              <p class="caption text-first">
                Informasi Unit (bisa dikosongi)
              </p>
              <v-autocomplete
                chips
                multiple
                dense
                outlined
                single-line
                label="Pilih Fasilitas Pribadi"
                :color="style.primary"
                hide-details
                clearable
                prepend-inner-icon="mdi-timeline-check-outline"
                :items="config.facility"
                item-value="facility_id"
                item-text="facility_name"
                return-object
                v-model="form.detail.facility">
                <template v-slot:append>
                  <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                </template>
                <template v-slot:selection="data">
                  <v-chip
                    small
                    v-bind="data.attrs"
                    :input-value="data.selected.type"
                    close
                    class="ma-1"
                    color="#B2B2B2"
                    text-color="white"
                    @click="data.select"
                    @click:close="removeFacility(data.item)">
                    {{ data.item.facility_name }}
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-item-content v-text="data.item"></v-list-item-content>
                  </template>
                  <template v-else>
                    <v-list-item-content>
                      <v-list-item-title v-html="data.item.facility_name"></v-list-item-title>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
              <p class="caption pt-2" v-if="!addFacility">
                <span class="text-second">
                  Tambah fasilitas jika diatas tidak ada
                </span>
                <router-link to="/setting/facility" target="_blank">
                  <span class="light-green--text" @click="addFacility = true">
                    Tambah disini
                  </span>
                </router-link>
              </p>
              <p class="caption pt-2" v-if="addFacility">
                <span class="text-second">
                  Silahkan refresh data yang anda tambahkan
                </span>
                <span class="light-green--text cursor-pointer" @click="setting().facility()">
                  Refresh disini
                </span>
              </p>
              <v-currency-field 
                dense
                outlined
                single-line
                label="Harga Unit (bisa dikosongi)"
                :color="style.primary"
                prepend-inner-icon="mdi-home-currency-usd"
                v-model="form.detail.price">
              </v-currency-field>
              <v-row>
                <v-col cols="6" class="py-0">
                  <v-row>
                    <v-col cols="9" class="py-0 pr-0">
                      <v-text-field
                        type="number"
                        dense
                        outlined
                        single-line
                        label="Luas Tanah"
                        :color="style.primary"
                        prepend-inner-icon="mdi-home-floor-l"
                        v-model="form.detail.area">
                      </v-text-field>
                    </v-col>
                    <v-col cols="2" class="py-0"
                      style="position: relative; left: -29px;">
                      <v-btn
                        style="border-radius: 0px 4px 4px 0px;"
                        height="40"
                        elevation="0"
                        color="grey"
                        class="text-capitalize white--text">
                        m<span style="font-size: 7px; position: relative; top: -5px; margin-left: 2px;">2</span>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="6" class="py-0">
                  <v-row>
                    <v-col cols="9" class="py-0 pr-0">
                      <v-text-field
                        type="number"
                        dense
                        outlined
                        single-line
                        label="Luas Bangunan"
                        :color="style.primary"
                        prepend-inner-icon="mdi-home-floor-l"
                        v-model="form.detail.building">
                      </v-text-field>
                    </v-col>
                    <v-col cols="2" class="py-0"
                      style="position: relative; left: -29px;">
                      <v-btn
                        style="border-radius: 0px 4px 4px 0px;"
                        height="40"
                        elevation="0"
                        color="grey"
                        class="text-capitalize white--text">
                        m<span style="font-size: 7px; position: relative; top: -5px; margin-left: 2px;">2</span>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <quill-editor 
                ref="myTextEditor"
                :options="option"
                v-model="form.detail.description">
              </quill-editor>
            </v-form>
          </ValidationObserver>
        </v-card-text>

        <v-card-text class="pt-0 pb-0">
          <v-alert type="error" text dense prominent 
            v-show="error.message.length > 0"
            v-html="error.message">
          </v-alert>
        </v-card-text>
        <v-card-actions class="pa-5">
          <v-spacer/>
          <v-btn
            width="150"
            elevation="3"
            :color="style.primary"
            class="text-capitalize white--text"
            :loading="process.run"
            :disabled="process.run"
            @click="save('close')">
            <v-icon small class="mr-1">mdi-check</v-icon>
            Tambahkan
          </v-btn>
          <v-btn 
            text 
            color="red"
            class="text-capitalize white--text"
            :disabled="process.run"
            @click="reset(); $refs.observer.reset(); updateForm();">
            Batalkan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.delete" 
      persistent
      width="400">
      <v-card class="border-radius box-shadow">
        <v-card-title class="body-2 text-first justify-center">
          Hapus Tipe Unit
        </v-card-title>
        <v-card-text v-if="unit.length > 0">
          Apakah anda yakin menghapus Unit Tipe
          <span class="font-weight-bold">
            {{ unit[selected.type].unit_type_name }}
          </span>
          ?
        </v-card-text>
        <v-card-text class="pt-0 pb-0">
          <v-alert type="error" text dense prominent 
            v-show="error.message.length > 0"
            v-html="error.message">
          </v-alert>
        </v-card-text>
        <v-card-actions class="pa-5">
          <v-spacer/>
          <v-btn
            small
            color="red"
            elevation="3"
            class="text-capitalize white--text mx-1"
            :loading="process.run"
            :disabled="process.run"
            @click="removeUnitType()">
            <v-icon small class="mr-1">mdi-trash-can-outline</v-icon>
            Ya, hapus
          </v-btn>
          <v-btn
            small
            outlined
            class="text-capitalize red--text mx-1"
            :disabled="process.run"
            @click="dialog.delete = false;">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Tidak
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.unit" 
      persistent
      width="500">
      <v-card class="border-radius box-shadow">
        <v-card-title class="body-2 text-first justify-center">
          Ubah Unit
        </v-card-title>
        <v-card-title v-if="form.label.length > 0">
          <v-form style="width: 100%;">
            <v-chip
              v-if="searching(form.label)[selected.unit].status === 'sold'"
              small
              color="red"
              label
              text-color="white">
              <v-icon small left>mdi-cash-check</v-icon>
              Sudah Diboking
            </v-chip>
            <v-text-field
              dense
              outlined
              single-line
              label="Unit"
              :color="style.primary"
              prepend-inner-icon="mdi-home-import-outline"
              :disabled="searching(form.label)[selected.unit].status === 'sold'"
              v-model="searching(form.label)[selected.unit].unit">
            </v-text-field>

            <v-radio-group
              v-model="searching(form.label)[selected.unit].unit_jenis"
              row
              dense
              class="ma-0 pa-0">
              <v-radio
                :color="style.primary"
                label="Subsidi"
                value="Subsidi">
                <template v-slot:label>
                  <div :class="searching(form.label)[selected.unit].unit_jenis === 'Subsidi' ? 'color-default font-weight-bold' : ''">Subsidi</div>
                </template>
              </v-radio>
              <v-radio
                :color="style.primary"
                label="Komersil"
                value="Non Subsidi">
                <template v-slot:label>
                  <div :class="searching(form.label)[selected.unit].unit_jenis === 'Non Subsidi' ? 'color-default font-weight-bold' : ''">Komersil</div>
                </template>
              </v-radio>
            </v-radio-group>

            <v-autocomplete
              chips
              multiple
              dense
              outlined
              single-line
              label="Pilih Fasilitas Pribadi"
              :color="style.primary"
              clearable
              prepend-inner-icon="mdi-timeline-check-outline"
              :items="config.facility"
              item-value="facility_id"
              item-text="facility_name"
              return-object
              :disabled="searching(form.label)[selected.unit].status === 'sold'"
              v-model="searching(form.label)[selected.unit].facility">
              <template v-slot:append>
                <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
              </template>
              <template v-slot:selection="data">
                <v-chip
                  small
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  close
                  class="ma-1"
                  color="#B2B2B2"
                  text-color="white"
                  @click="data.select"
                  @click:close="removeFacility(data.item)">
                  {{ data.item.facility_name }}
                </v-chip>
              </template>
              <template v-slot:item="data">
                <template v-if="typeof data.item !== 'object'">
                  <v-list-item-content v-text="data.item"></v-list-item-content>
                </template>
                <template v-else>
                  <v-list-item-content>
                    <v-list-item-title v-html="data.item.facility_name"></v-list-item-title>
                  </v-list-item-content>
                </template>
              </template>
            </v-autocomplete>
            <v-currency-field 
              dense
              outlined
              single-line
              label="Harga"
              :color="style.primary"
              prepend-inner-icon="mdi-home-import-outline"
              :disabled="searching(form.label)[selected.unit].status === 'sold'"
              v-model="searching(form.label)[selected.unit].price">
            </v-currency-field>
            <v-row>
              <v-col cols="6" class="py-0">
                <v-row>
                  <v-col cols="9" class="py-0 pr-0">
                    <v-text-field
                      type="number"
                      dense
                      outlined
                      single-line
                      label="Luas Tanah"
                      :color="style.primary"
                      prepend-inner-icon="mdi-home-floor-l"
                      :disabled="searching(form.label)[selected.unit].status === 'sold'"
                      v-model="searching(form.label)[selected.unit].area">
                    </v-text-field>
                  </v-col>
                  <v-col cols="2" class="py-0"
                    style="position: relative; left: -29px;">
                    <v-btn
                      style="border-radius: 0px 4px 4px 0px;"
                      height="40"
                      elevation="0"
                      color="grey"
                      class="text-capitalize white--text">
                      m<span style="font-size: 7px; position: relative; top: -5px; margin-left: 2px;">2</span>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6" class="py-0">
                <v-row>
                  <v-col cols="9" class="py-0 pr-0">
                    <v-text-field
                      type="number"
                      dense
                      outlined
                      single-line
                      label="Luas Bangunan"
                      :color="style.primary"
                      prepend-inner-icon="mdi-home-floor-l"
                      :disabled="searching(form.label)[selected.unit].status === 'sold'"
                      v-model="searching(form.label)[selected.unit].building">
                    </v-text-field>
                  </v-col>
                  <v-col cols="2" class="py-0"
                    style="position: relative; left: -29px;">
                    <v-btn
                      style="border-radius: 0px 4px 4px 0px;"
                      height="40"
                      elevation="0"
                      color="grey"
                      class="text-capitalize white--text">
                      m<span style="font-size: 7px; position: relative; top: -5px; margin-left: 2px;">2</span>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <quill-editor 
              ref="myTextEditor"
              :options="option"
              v-model="searching(form.label)[selected.unit].description">
            </quill-editor>
          </v-form>
        </v-card-title>
        <v-card-actions class="pa-5">
          <v-spacer/>
          <v-btn
            width="150"
            elevation="3"
            :color="style.primary"
            class="text-capitalize white--text"
            :loading="process.run"
            :disabled="process.run"
            @click="dialog.unit = false">
            <v-icon small class="mr-1">mdi-check</v-icon>
            Simpan
          </v-btn>
          <v-btn 
            text 
            color="red"
            class="text-capitalize white--text"
            :disabled="process.run"
            @click="dialog.unit = false; fetch();">
            Batalkan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row justify="end">
      <v-col>
        <ul class="steps mb-5">
          <router-link :to="`/project/update/${detail.id}`">
            <li class="current">
              <a href="#" title="" class="caption d-flex align-center">
                <v-icon color="white" small class="mr-1">mdi-home-edit-outline</v-icon>
                Informasi Proyek
              </a>
            </li>
          </router-link>
          <li class="current">
            <a href="#" title="" class="caption d-flex align-center">
              <v-icon color="white" small class="mr-1">mdi-home-plus-outline</v-icon>
              Jenis / Tipe / Unit
            </a>
          </li>
        </ul>
        <v-card
          class="border-radius box-shadow pa-5" 
          min-height="635" v-if="!first">
          <v-row justify="center" align="center" class="py-5">
            <v-col cols="3" class="text-center" style="margin: 10em;">
              <v-card
                height="200"
                width="200"
                color="#EEEEEE"
                class="border-radius box-shadow ma-auto py-8"
                @click="reset()">
                <div v-if="!process.first">
                  <v-card-title class="justify-center">
                    <v-icon style="font-size: 60px;" color="grey">mdi-plus-circle-outline</v-icon>
                  </v-card-title>
                  <v-card-text class="subtitle-1 text-center text-second">
                    Tambah Unit Baru
                  </v-card-text>
                </div>
                <div v-if="process.first">
                  <v-card-title class="justify-center">
                    <v-progress-circular
                      :size="70"
                      :width="7"
                      color="grey"
                      indeterminate>
                    </v-progress-circular>
                  </v-card-title>
                  <v-card-text class="subtitle-1 text-center text-second">
                    Loading
                  </v-card-text>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
        <v-card
          class="border-radius box-shadow"
          min-height="500" v-if="first">
          <v-row>
            <v-col cols="3" class="text-center pa-0 d-flex">
              <div class="pa-0" style="width: 100%">
                <v-card-title class="body-2 d-flex align-center green--text pl-7 cursor-pointer" @click="reset()">
                  <v-icon color="green" class="title mr-1">mdi-plus</v-icon>
                  Jenis / Tipe / Unit Baru
                </v-card-title>
                <v-card-text class="py-0 pl-3 pr-0">
                  <v-divider/>
                </v-card-text>
                <v-card-text class="py-0 pl-3 pr-0">
                  <v-list dense class="pa-0">
                    <v-list-item-group
                      v-model="selected.type"
                      no-action
                      active-class="white--text">
                      <template v-for="(item, index) in unit">
                        <v-list-item :key="index">
                          <template v-slot:default="{ active, toggle }">
                            <v-list-item-content class="pa-0">
                              <v-list-item-title class="text-left" :class="active ? 'green--text' : ''">
                                {{ item.unit_type_name }}
                              </v-list-item-title>
                            </v-list-item-content>

                            <v-list-item-action class="my-0">
                              <v-list-item-action-text :class="active ? 'green--text' : ''">
                                {{ item.unit_type_total_unit }} Unit
                              </v-list-item-action-text>
                            </v-list-item-action>
                          </template>
                        </v-list-item>

                        <v-divider />
                      </template>
                    </v-list-item-group>
                  </v-list>
                </v-card-text>
              </div>
              <div class="pa-0">
                <v-divider vertical />
              </div>
            </v-col>
            <v-col cols="9" style="min-height: 650px;">
              <v-card-title>
                <span class="body-2 text-first">
                  {{ detail.name }} - <span class="text-third">{{ form.name }}</span>
                </span>
                <v-spacer/>
                <v-btn
                  outlined
                  x-small
                  width="130"
                  color="red"
                  class="text-capitalize"
                  @click="dialog.delete = true">
                  Hapus Tipe Unit Ini
                </v-btn>
              </v-card-title>
              <v-divider class="mx-4"/>
              <v-row>
                <v-col cols="12" md="4" class="ml-3">
                  <v-text-field
                    outlined
                    dense
                    :hide-details="true"
                    placeholder="Cari Unit . . ."
                    clearable
                    color="#4FC3F7"
                    v-model="filter.title"
                    @click:clear="filter.title = ''"
                    prepend-inner-icon="mdi-magnify">
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row class="ml-0 mr-3">
                <v-col cols="12" md="2"
                  v-for="(item, index) in searching(form.label)"
                  :key="index">
                  <v-card
                    class="box-shadow py-3"
                    style="border-radius: 10px;"
                    :color="item.status === 'sold' ? 'red' : ''">
                    <v-card-text class="font-weight-bold py-0 d-flex align-center"
                      :class="item.status === 'sold' ? 'white--text' : ''">
                      <div>
                        {{ item.unit }}
                      </div>
                      <v-spacer/>
                      <div class="text-right">
                        <v-btn
                          style="position: absolute; top: 7px; right: 7px;"
                          small
                          icon
                          @click="dialog.unit = true; selected.unit = index">
                          <v-icon x-small :color="item.status === 'sold' ? 'white' : 'orange'">mdi-pencil-outline</v-icon>
                        </v-btn>
                      </div>
                    </v-card-text>
                    <v-card-text class="text-second d-flex align-center py-1 pb-0" style="font-size: 10px;">
                      <div :class="item.status === 'sold' ? 'white--text' : ''">
                        <v-icon x-small :color="item.status === 'sold' ? 'white' : ''">mdi-home-floor-l</v-icon>
                        Luas Tanah
                      </div>
                      <v-spacer/>
                      <div :class="item.status === 'sold' ? 'white--text' : ''">
                        {{ item.area }} M<span style="font-size: 7px; position: relative; top: -5px; margin-left: 2px;">2</span>
                      </div>
                    </v-card-text>
                    <v-card-text class="text-second d-flex align-center py-0" style="font-size: 10px;">
                      <div :class="item.status === 'sold' ? 'white--text' : ''">
                        <v-icon x-small :color="item.status === 'sold' ? 'white' : ''">mdi-home-floor-l</v-icon>
                        Luas Bangunan
                      </div>
                      <v-spacer/>
                      <div :class="item.status === 'sold' ? 'white--text' : ''">
                        {{ item.building }} M<span style="font-size: 7px; position: relative; top: -5px; margin-left: 2px;">2</span>
                      </div>
                    </v-card-text>
                    <v-card-text class="caption font-weight-bold pb-0 text-right"
                      :class="item.status === 'sold' ? 'white--text' : 'text-second'">
                      {{ item.price | price }}
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
        <v-card-actions class="py-12">
          <v-spacer/>
          <v-btn
            width="150"
            elevation="3"
            color="grey"
            class="text-capitalize white--text"
            :disabled="process.run"
            :to="`/project/update/${detail.id}`">
            <v-icon small class="mr-1">mdi-chevron-left</v-icon>
            Sebelumnya
          </v-btn>
          <v-btn
            width="150"
            elevation="3"
            color="teal"
            class="text-capitalize white--text"
            :loading="process.run"
            :disabled="process.run"
            @click="save('next')">
            Selesai
            <v-icon small class="ml-1">mdi-check</v-icon>
          </v-btn>
          <v-spacer/>
        </v-card-actions>
      </v-col>
    </v-row>
    
    <v-fab-transition>
      <v-btn
        class="mx-8 my-3"
        v-scroll="onScroll"
        v-show="fab"
        elevation="3"
        fab
        width="50"
        height="50"
        dark
        fixed
        bottom
        right
        :color="style.primary"
        @click="$vuetify.goTo('#app', {duration: 500, offset: 0})">
        <v-icon>mdi-chevron-up</v-icon>
      </v-btn>
    </v-fab-transition>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../../../service/Axios";
  import ImageInput from "../../../../components/ImageInput.vue";
  export default {
    data () {
      return {
        fab: false,
        option: {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline'],
              [{ 'list': 'ordered'}, { 'list': 'bullet' }],
              [{ 'size': ['small', false, 'large', 'huge'] }],
              [{ 'color': [] }, { 'background': [] }],
              [{ 'align': [] }]
            ]
          },
          placeholder: 'Keterangan'
        },
        filter: {
          title: ''
        },
        dialog: {
          form: false,
          delete: false,
          unit: false
        },
        selected: {
          type: 0,
          unit: 0
        },
        addFacility: false,
        first: false,
        config: {
          facility: []
        },
        detail: {},
        images: [],
        form: {
          id: '',
          project_id: '',
          name: '',
          total_unit: '',
          published_status: 'publish',
          detail: {
            prefix: '',
            facility: [],
            price: '',
            area: '',
            building: '',
            description: ''
          },
          label: [],
          unit_delete: []
        },
        unit: [],
        process: {
          first: false,
          run: false
        },
        error: {
          message: ''
        },
        style: {
          primary: "#8BC541"
        }
      }
    },
    components: {
      ImageInput
    },
    computed: {
      
    },
    watch: {
      images: {
        handler: function (val) {
          let t = this
          val.forEach(function(item, index) {
            if (item.url) {
              t.form.label[index].images.push(item.url)
              t.form.label[index].images = [...new Set(t.form.label[index].images)]
            }
          })
        },
        deep: true
      },
      'selected.type': function(val) {
        if (val !== undefined) {
          //console.log(val)
          this.save('close')
        } else {
          this.selected.type = 0
        }
      }
    },
    mounted () {
      this.fetch()
      this.setting().facility()
    },
    methods: {
      searching(input) {
        let t = this
        return this.form.label.filter(function(item) {
          t.filter.title = t.filter.title === null ? '' : t.filter.title
          let regex = new RegExp('(' + t.filter.title + ')', 'i')
          return item.unit.match(regex)
        })
      },
      onScroll (e) {
        if (typeof window === 'undefined') return
        const top = window.pageYOffset || e.target.scrollTop || 0
        this.fab = top > window.innerHeight-100
      },
      fetch() {
        this.process.first = true
        get(`auth/company/project/detail`, {
          params: {
            id: this.$route.params.id
          }
        })
        .then(response => {
          let res = response.data
          if (res.status == 200) {
            this.process.first = false
            this.detail = res.data
            this.unit = res.data.unit_type
            
            if (this.unit.length > 0) {
              this.updateForm()
              this.first = true
            }

            this.$vuetify.goTo('#app', {duration: 500, offset: 0})
          }
        })
      },
      setting() {
        let t = this
        return {
          async facility() {
            get(`project/facility/get-list-option`, {
              params: {
                type: 'all,private'
              }
            })
            .then(response => {
              let res = response.data;
              if (res.status == 200) {
                t.config.facility = res.data.results
                t.addFacility = false
              }
            })
          }
        }
      },
      updateForm() {
        if (this.selected.type === undefined) {
          this.selected.type = 0
        }

        let item = this.unit[this.selected.type] // form mengambil index ke 0 / index yang di select
        let label = []
        for (let i in item.unit) { 
          label.push(item.unit[i].unit_detail)
        }
        this.form = {
          id: item.unit_type_id,
          project_id: item.unit_type_project_id,
          name: item.unit_type_name,
          total_unit: item.unit_type_total_unit,
          published_status: item.unit_type_published_status,
          detail: item.unit_type_detail,
          label: label,
          unit_delete: []
        }
      },
      reset(item) {
        this.dialog.form = !this.dialog.form ? true : false
        
        this.form = {
          id: item !== undefined ? item.unit_type_id : '',
          project_id: item !== undefined ? item.unit_type_project_id : this.detail.id,
          name: item !== undefined ? item.unit_type_name : '',
          total_unit: item !== undefined ? item.unit_type_total_unit : '',
          published_status: item !== undefined ? item.unit_type_published_status : 'publish',
          detail: item !== undefined ? item.unit_type_detail : {
            prefix: '',
            facility: [],
            price: '',
            area: '',
            building: '',
            description: '',
            unit_jenis: 'Subsidi'
          },
          label: item !== undefined ? item.unit : [],
          unit_delete: []
        }
      },
      removeFacility (item) {
        const index = this.form.detail.facility.findIndex(v => v.facility_id === item.facility_id)
        if (index >= 0) this.form.detail.facility.splice(index, 1)
      },
      async removeUnitType() {
        this.error.message = ''
        this.process.run = true

        await post(`auth/company/unit-type/delete`, {
          data: {
            id: JSON.stringify([this.unit[this.selected.type].unit_type_id])
          }
        }).then(response => {
          let res = response.data
          if (res.status === 200) {
            this.dialog.delete = false
            this.process.run = false
            this.selected.type = 0
            this.form.label = []
            this.fetch()
          } else {
            this.process.run = false
            this.error.message = res.msg
          }
        })
      },
      save(type) {
        if (this.form.id.length < 1) {
          this.creates()
        } else {
          this.updates(type)
        }
      },
      labels() {
        let total = this.form.total_unit

        this.form.label = []
        
        for (let i = 1; i <= total; i++) {
          this.form.label.push({
            id: 0,
            no: i,
            unit: `${this.form.detail.prefix} ${i}`,
            facility: this.form.detail.facility,
            price: this.form.detail.price,
            area: this.form.detail.area,
            building: this.form.detail.building,
            description: this.form.detail.description,
            images: [],
            status: 'available',
            unit_jenis: this.form.detail.unit_jenis,
          })
        }

        this.first = true
      },
      async creates() {
        this.error.message = ''
        this.process.run = true
        
        this.labels()
        
        let forms = Object.assign({}, this.form)
        forms.detail = JSON.stringify(forms.detail)
        forms.label = JSON.stringify(forms.label)
        forms.unit_delete = JSON.stringify(forms.unit_delete)

        await post(`auth/company/unit-type/form`, {
          data: forms
        }).then(response => {
          let res = response.data
          if (res.status === 200) {
            this.dialog.form = false
            this.process.run = false
            this.fetch()
          } else {
            this.process.run = false
            this.error.message = res.msg
          }
        })
      },
      async updates(type) {
        this.error.message = ''
        this.process.run = true
        
        let forms = Object.assign({}, this.form)
        forms.detail = JSON.stringify(forms.detail)
        forms.label = JSON.stringify(forms.label)
        forms.unit_delete = JSON.stringify(forms.unit_delete)
        
        await post(`auth/company/unit-type/form`, {
          data: forms
        }).then(response => {
          let res = response.data
          if (res.status === 200) {
            if (type === 'close') {
              this.process.run = false
              this.fetch()
            } else {
              this.$router.push({ path: `/project/detail/${this.$route.params.id}` })
            }
          } else {
            this.process.run = false
            this.error.message = res.msg
          }
        })
      }
    }
  }
</script>

<style scoped>
.steps {
  margin: 0px;
  padding: 0;
  overflow: hidden;
  border-radius: 5px;
}
.steps a {
  color: white;
  text-decoration: none;
}
.steps li {
  float: left;
  margin-left: 0;
  width: 175px; /* 100 / number of steps */
  height: 45px; /* total height */
  list-style-type: none;
  padding: 12px 5px 5px 30px; /* padding around text, last should include arrow width */
  border-right: 3px solid white; /* width: gap between arrows, color: background of document */
  position: relative;
}
/* remove extra padding on the first object since it doesn't have an arrow to the left */
.steps li:first-child {
  padding-left: 15px;
}
/* white arrow to the left to "erase" background (starting from the 2nd object) */
.steps li:nth-child(n+2)::before {
  position: absolute;
  top:0;
  left:0;
  display: block;
  border-left: 20px solid white; /* width: arrow width, color: background of document */
  border-top: 22.5px solid transparent; /* width: half height */
  border-bottom: 22.5px solid transparent; /* width: half height */
  width: 0;
  height: 0;
  content: " ";
}
/* colored arrow to the right */
.steps li::after {
  z-index: 1; /* need to bring this above the next item */
  position: absolute;
  top: 0;
  right: -20px; /* arrow width (negated) */
  display: block;
  border-left: 20px solid #7c8437; /* width: arrow width */
  border-top: 22.5px solid transparent; /* width: half height */
  border-bottom: 22.5px solid transparent; /* width: half height */
  width:0;
  height:0;
  content: " ";
}

/* Setup colors (both the background and the arrow) */

/* Current */
.steps li.current { background-color: var(--color-primary); border-right: none;  }
.steps li.current::after { border-left-color: var(--color-primary); }

/* Hover for completed and current */
.steps li:hover {background-color: #ffb74d}
.steps li:hover::after {border-left-color: #ffb74d}
</style>